module.exports = __webpack_public_path__ + "static/tip_2-c4f78fa32dce78ef8b3c55205e30eeb5.jpg";